{
  "id": 12,
  "documentId": "l8m7pq9e9k1sj7am9rva5g63",
  "name": "Baharudin Yusup",
  "slug": "baharudin-yusup",
  "headline": "Senior Mobile Engineer and Technical Lead",
  "summary": "Senior Mobile Engineer and Technical Lead with 8+ years building apps used by millions, including Avis & Budget (car-rental giant, 15M+ users), UOB (one of Singapore's largest banks), Scoot (regional airline), and BRI (Indonesia's largest state-owned bank). Ships production apps across the full mobile spectrum: native Android, iOS, Flutter, and React Native. Has led migrations across that spectrum: Java to Flutter, eight apps into one React Native codebase, and now legacy Kotlin/XML and Swift/UIKit into Jetpack Compose and SwiftUI.",
  "shortBio": "Senior Mobile Engineer and Technical Lead with 8+ years building apps used by millions, across native Android, iOS, Flutter, and React Native.",
  "location": "Bangkok, Thailand",
  "timezone": "Asia/Bangkok",
  "website": "https://www.baharudin.dev",
  "dateOfBirth": null,
  "languages": null,
  "interests": null,
  "email": "baharudin.yusup@outlook.com",
  "phone": null,
  "createdAt": "2025-08-05T12:23:57.991Z",
  "updatedAt": "2026-08-14T09:15:20.929Z",
  "publishedAt": "2026-08-14T09:15:20.944Z",
  "avatar": null,
  "coverImage": null,
  "socialLinks": [
    {
      "id": 373,
      "label": "LinkedIn",
      "url": "https://www.linkedin.com/in/baharudin-yusup",
      "type": "linkedin",
      "showIcon": true,
      "isExternal": true,
      "description": "Professional profile",
      "isVisible": true
    },
    {
      "id": 374,
      "label": "GitHub",
      "url": "https://github.com/baharudin-yusup",
      "type": "github",
      "showIcon": true,
      "isExternal": true,
      "description": "Code repositories and projects",
      "isVisible": true
    }
  ],
  "resume": null
}
